export default {
	"exceptcreate": {
		"getFileLable": "รับรูปภาพ/เอกสารแนบที่เกี่ยวข้องโดยอัตโนมัติ"
	},
	"exceptdeal": {
		"batchRe": "ประมวลผลใหม่",
		"exceptionStatus": "สถานะผิดปกติ",
		"handlePerson": "ผู้ดูแล",
		"exceptionGrade": "ระดับข้อยกเว้น",
		"exceptionReason": "ผิดปกติ",
		"overdueTime": "การจัดการเวลาที่เกินกำหนด",
		"exceptionFinish": "เสร็จสิ้นการประมวลผล",
		"exceptionInfo": "ข้อมูลข้อยกเว้น",
		"slight": "เล็กน้อย",
		"serious": "ร้ายแรง",
		"losingPartner": "ฝ่ายที่รับผิดชอบ",
		"our": "ฝ่ายเรา",
		"other": "ฝ่ายอื่น",
		"compensation": "จำนวนเงินชดเชย ",
		"tips": "ผู้รับผิดชอบ (กด Enter เพื่อกรอกโดยตรง)",
		"tips1": "กรุณาระบุผู้รับผิดชอบ",
		"executDescription": "คำแนะนำในการจัดการ",
		"exceptionDescription": "คำอธิบายข้อยกเว้น",
		"tips2": "กรุณาเลือกแถวที่มีสถานะ ประมวลผลแล้ว หรือ ปิดแล้ว",
		"tips3": "สถานะต้องเป็น Processed หรือ Closed เพื่อดำเนินการใหม่อีกครั้ง",
		"tisp4": "ท่านแน่ใจว่าต้องการประมวลผลใหม่หรือไม่",
		"tisp5": "กรุณาบันทึกก่อนยืนยัน",
		"tisp6": "สถานะข้อยกเว้นต้องเป็นสถานะ New",
		"exceptionExecuteLable": "คำจำกัดความของคำว่าความรับผิดชอบ",
		"exceptdealTitle": "การจัดการข้อยกเว้น",
		"cancelDeal": "การประมวลผลซ้ำถูกยกเลิก"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/except/except.js